import React from 'react';
import { Tree } from '@myua/kit';
import { useSelector, useDispatch } from 'react-redux';
import {
  getExtensions,
  getLoading,
  getSelectedIds,
  getTreeData,
  getExpandedKeys,
} from '../selectors';
import { TreeSkeleton } from '../../skeleton/components/Skeleton';
import { Extension } from '../../../api';
import * as extensionActions from '../actions';
import { ALL_EXTENSIONS_ID } from '../model';
import { useHistory } from 'react-router-dom';
import { getPage } from '../../router/selectors';
import { routes, Page } from '../../router/model';
import '../styles.scss';
import { ArrowDown } from '@myua/icons/dist/linear14';

export const Extensions = () => {
  const dispatch = useDispatch();
  const treeData = useSelector(getTreeData);
  const selectedKeys = useSelector(getSelectedIds);
  const expandedKeys = useSelector(getExpandedKeys);
  const loading = useSelector(getLoading);
  const extensions = useSelector(getExtensions);
  const page = useSelector(getPage);
  const history = useHistory();

  const select = (ids: Extension['id'][]) => {
    dispatch(extensionActions.extensionsSelected({ ids, saveLastState: true }));
    if (page !== Page.viewer) {
      history.push(routes.viewer);
    }
  };

  // Скелетон только когда показывать нечего — фоновое обновление проходит незаметно.
  if (loading && extensions.length === 0) {
    return (
      <div className="al-extensions" aria-busy>
        <TreeSkeleton rows={5} />
      </div>
    );
  }

  return (
    <div className="al-extensions">
      <div className="al-fade-in">
        <Tree
          className="al-app-sider-tree"
          switcherIcon={<ArrowDown />}
          treeData={treeData}
          // Если expandedKeys обновились до появления их в treeData, то Ant воспримет их,
          // только если это будет новый объект. Такое происходит при загрузке lastState.
          expandedKeys={[...expandedKeys]}
          selectedKeys={selectedKeys}
          multiple
          onSelect={(ids) => {
            if (selectedKeys.includes(ALL_EXTENSIONS_ID)) {
              const newIds = ids.filter((id) => id !== ALL_EXTENSIONS_ID);
              if (newIds.length > 0) {
                select(ids.filter((id) => id !== ALL_EXTENSIONS_ID) as Extension['id'][]);
              }
            } else {
              if (ids.length === 0) {
                select([ALL_EXTENSIONS_ID]);
              } else if (ids.includes(ALL_EXTENSIONS_ID)) {
                select([ALL_EXTENSIONS_ID]);
              } else {
                select(ids as Extension['id'][]);
              }
            }
          }}
          onExpand={(keys) =>
            dispatch(
              extensionActions.setExpandedKeys({
                keys: keys as Extension['id'][],
                saveLastState: true,
              }),
            )
          }
        />
      </div>
    </div>
  );
};
